import { previewContactOrdersBatch } from "../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderPlanningOperations } from "../../../_shared/_logic/contact-orders-contract"
import { executeCreateContactOrders } from "../execute"

export const domainContactOrderPlanningOperations: ContactOrderPlanningOperations = {
  previewContactOrders: previewContactOrdersBatch,
  createContactOrders: async (input) => ({
    ...(await executeCreateContactOrders(input)),
    receipt: undefined,
  }),
}
